import { render, staticRenderFns } from "./ViewPaymentType.vue?vue&type=template&id=762be298"
import script from "./ViewPaymentType.vue?vue&type=script&lang=js"
export * from "./ViewPaymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports